export function getApiUrl() {
  return process.env.API_URL ? process.env.API_URL : 'http://localhost:3007';
}



// WEBPACK FOOTER //
// ./src/utils/getApiUrl.js